import { Select as AntSelect } from 'antd';
import type { SelectProps as AntSelectProps } from 'antd';

import { cn } from '../../lib/cn';

/**
 * Ô chọn (§9.3.11). Chuyển tiếp thuần, chỉ thêm `min-w-[8rem]` mặc định.
 * Dùng prop của antd: `options`, `mode`, `showSearch`, `loading`, `status`,
 * `allowClear`.
 */
export function Select<ValueType = unknown>({
  className,
  ...props
}: AntSelectProps<ValueType>) {
  return <AntSelect<ValueType> className={cn('min-w-[8rem]', className)} {...props} />;
}
